import { useRef } from "react";

export function useTimeout() {
  const ref = useRef<ReturnType<typeof setTimeout>>(null);
  return {
    setTimeout(fn: () => void, ms?: number) {
      if (ref.current) clearTimeout(ref.current);
      ref.current = setTimeout(fn, ms);
    },
  };
}
